module.exports = __webpack_public_path__ + "static/img/column_img_5-1.01997528.png";